"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSquareFoot = void 0;
/**
 * Convert the given {@link sqm} to {@link SquareFoot}.
 * This operation is one way and only intended for visualisation.
 *
 * **DO NOT** persist this value, instead store the original {@link SquareMeter}.
 */
const toSquareFoot = (sqm) => {
    return sqm * 10.7639;
};
exports.toSquareFoot = toSquareFoot;
